import "stylesheets/components/common/Modal.css";
import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { ActionRootContext } from "higher-order/ActionRoot";

@observer
class Modal extends React.Component {
    static propTypes = {
        modalKey: PropTypes.string.isRequired,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
        isOpen: PropTypes.bool,
        allowScrollBar: PropTypes.bool,
        hideHeader: PropTypes.bool,
        shouldCloseOnOverlayClick: PropTypes.bool,
        enableDefaultCloseButton: PropTypes.bool,
        className: PropTypes.string
    }

    static contextType = ActionRootContext;

    componentDidMount() {
        if (this.props.isOpen) {
            // Have to defer this to give the ModalContainer a chance to mount.
            setTimeout(() => {
                this.updateDisplay(this.props);
            }, 0);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen) {
            this.updateDisplay(this.props);
        } else if (prevProps.isOpen) {
            this.hidePortal(this.props);
        }
    }

    componentWillUnmount() {
        if (this.props.isOpen) {
            this.hidePortal(this.props);
        }
    }

    // Pass updated props along to the portaled-content every time the actual content is updated.
    updateDisplay(props) {
        this.context.dispatcher.emit("SHOW_MODAL", props);
    }

    hidePortal(props) {
        this.context.dispatcher.emit("HIDE_MODAL", {
            modalKey: props.modalKey
        });
    }

    render() {
        // The actual content is rendered inside of a ModalPortal component.
        return null;
    }
}

export default Modal;
